import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { ArrowRight, Sparkles } from 'lucide-react';
import { cn } from '@/lib/utils';
import { earnCreditApi } from '@/lib/earnCreditApi';
import { REWARDS_SECTION_CARD } from '@/constants/brandColors';
import { EARN_CREDIT_ACTIONS, formatEarnAmount } from '@/constants/earnCreditProgram';

/**
 * The Rewards page's door to /earn. Renders nothing until the server says the
 * program is on (EARN_CREDIT_ENABLED), so it stays invisible before launch.
 */
export default function EarnCreditPromo({ className }) {
  const [enabled, setEnabled] = useState(false);

  useEffect(() => {
    let cancelled = false;
    earnCreditApi.overview()
      .then((d) => { if (!cancelled) setEnabled(Boolean(d?.enabled)); })
      .catch(() => {});
    return () => { cancelled = true; };
  }, []);

  if (!enabled) return null;
  const amount = formatEarnAmount(Math.max(...EARN_CREDIT_ACTIONS.map((a) => a.amountCents)));
  return (
    <div className={className}>
      <Link
        to="/earn"
        className={cn(REWARDS_SECTION_CARD, 'group flex items-center justify-between gap-4 p-5 sm:p-6 transition-colors hover:border-brand-700/55')}
      >
        <div className="flex items-start gap-4">
          <span className="flex h-11 w-11 flex-shrink-0 items-center justify-center rounded-2xl border border-brand-800/40 bg-brand-900/40">
            <Sparkles className="h-5 w-5 text-brand-200" aria-hidden="true" />
          </span>
          <div>
            <p className="text-[15px] text-white/90">Earn {amount} in Defera Credit</p>
            <p className="text-[13px] text-white/55 leading-relaxed">Post a video about your trip on TikTok, Instagram or YouTube. We review it and add the credit.</p>
          </div>
        </div>
        <ArrowRight className="h-5 w-5 flex-shrink-0 text-white/40 transition-transform group-hover:translate-x-0.5 group-hover:text-white/70" aria-hidden="true" />
      </Link>
    </div>
  );
}

EarnCreditPromo.propTypes = {
  className: PropTypes.string,
};
